import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const FiltersCardContainer = styled(CustomCard)`
  position: relative;
  margin-bottom: 16px;

  .ant-card-body {
    padding: 16px;
    border: none;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    background: ${({ theme }) => theme.colors.background1} !important;
  }

  .filters-card-header {
    margin: -8px;
    margin-bottom: 0;
    display: flex;

    justify-content: space-between;
  }

  label {
    font-size: calc(${({ theme }) => theme.fontSizes.verySmall} * 1.1);
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text1};
  }
`;

export const FiltersContainer = styled.div`
  .filters-button {
    margin-left: 8px;
  }

  .filters-button-clear {
    margin: 0 4px;
  }
`;
